<template>
  <section class="section-fndCheckout icons-bg">
    <div class="container">
      <div class="section-space-25"></div>
      <div class="row">
        <div class="col-md-8">
          <p class="text-rose-gold font-weight-600 h5">
            Delivering happiness at your seat
          </p>
          <p class="text-white">
            We deliver your orders directly to your seat during interval time so
            don’t worry about going to the counter in order to get your favorite
            snack!
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-9">
          <div
            class="row mx-md-0 py-0 py-md-4 rounded bg-dark-2"
            :class="window.width < 767 ? '' : 'shadow'"
            v-if="items.length > 0"
          >
            <div class="col-12 mb-3 mb-md-5">
              <h4>
                {{ getFndCinemaName }}
                <u>
                  <router-link
                    class="fs-12 underline text-rose-gold"
                    to
                    @click.native="onHandleOpenModal('cinemaModalModal')"
                    >(Change Cinema)</router-link
                  ></u
                >
              </h4>
            </div>

            <!-- Combos -->
            <div class="col-12 mb-3 mb-md-3">
              <ul class="list-inline mx-auto fnb-page-List text-center">
                <li
                  class="list-inline-item"
                  v-for="(fndItem, fndItemKey) in itemFilters"
                  :key="fndItemKey"
                >
                  <button
                    class="btn rounded-10 font-weight-600 w-100"
                    :class="
                      selectedFilter === fndItem.filter_id
                        ? 'btn-primary text-white'
                        : 'btn-outline-primary'
                    "
                    @click="onHandleFilter($event, fndItem)"
                    v-if="fndItem && fndItem.filter_name !== `Chef's Corner`"
                  >
                    {{ fndItem && fndItem.filter_name }}
                  </button>
                  <button
                    class="btn rounded-10 font-weight-600 w-100"
                    :class="
                      selectedFilter === fndItem.filter_id
                        ? 'btn-primary text-white'
                        : 'btn-outline-primary'
                    "
                    @click="onHandleFilter($event, fndItem)"
                    v-if="
                      fndItem &&
                      fndItem.filter_name === `Chef's Corner` &&
                      getFndCinema_has_chefs_corner
                    "
                  >
                    {{ fndItem && fndItem.filter_name }}
                  </button>
                </li>
              </ul>
              <!-- COMBO END -->
              <!-- <div class="has-chevron d-none d-md-block">
                <b-dropdown
                  no-caret
                  variant="transparent"
                  class="w-100 border rounded text-left dd-menu-100"
                >
                  <template v-slot:button-content>
                    <div class="text-left">
                      {{ selectedFilterName ? selectedFilterName : "All" }}
                    </div>
                  </template>
                  <b-dropdown-item
                    v-for="(fndItem, fndItemKey) in itemFilters"
                    :key="fndItemKey"
                    @click="onHandleFilter($event, fndItem)"
                    >{{ fndItem && fndItem.filter_name }}
                  </b-dropdown-item>
                </b-dropdown>
              </div> -->
              <!-- <div class="fnbCheckout-section">
                <ul class="list-inline d-md-none fnbCheckout mb-0 mb-md-2">
                  <li
                    class="list-inline-item pb-2"
                    :class="b == 1 ? 'active' : ''"
                    v-for="(a, b) in 10"
                    :key="b"
                  >
                    <div class="box">Combos SSS</div>
                  </li>
                </ul>
              </div> -->
            </div>
            <div
              :key="fndKey"
              v-for="(fnd, fndKey) in items"
              class="col-6 px-1 col-sm-6 col-md-6 col-lg-4 col-xl-4 mb-5"
            >
              <div class="fnd-card">
                <div class="fnd-img">
                  <div
                    :class="
                      fnd && fnd.item_category === 'V'
                        ? 'is-veg'
                        : fnd && fnd.item_category === 'N'
                        ? 'is-nonVeg'
                        : null
                    "
                  ></div>
                  <img v-lazy="getImageObject(fnd)" class="img-fluid" alt />
                  <label class="fnd-label">
                    {{ fnd && fnd.Item_strDescription }}
                  </label>
                </div>
                <div class="fnd-card-content">
                  <p class="fnd-item-description px-1">
                    {{ fnd && fnd.item_description }}
                  </p>
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <div>
                      <strong>₹{{ fnd && fnd.Item_intPrice }}</strong>
                    </div>

                    <div class="fnd-card-actions">
                      <button class="btn-sub" @click="removeItem(fnd)">
                        <span class="h-100 align-center">-</span>
                      </button>
                      <div class="qty">{{ fnd | quantity }}</div>
                      <button class="btn-add" @click="addItem(fnd)">
                        <span class="h-100 align-center">+</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <empty-state
            v-else
            isClass="border-0"
            :emptyMessage="`No items to show`"
            :isNeedTopSpace="true"
          /> -->
        </div>

        <div
          class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-3 d-none d-md-block"
        >
          <div class="mb-5" v-if="getStoreItems.length > 0">
            <div class="booking-summary">
              <header>BOOKING SUMMARY</header>
              <div class="summary-content">
                <div class="cinema-location">
                  {{ getFndCinemaName }}
                </div>
                <!-- <div class="showtime my-2">
                  Showtime:
                  <span>
                    {{ session && session.Session_dtmRealShow | timeparse }}
                  </span>
                </div> -->

                <table class="summary-table" v-if="getStoreItems.length > 0">
                  <tr>
                    <td colspan="2">
                      <div class="text-muted border-bottom pb-1 mb-2">
                        FOOD & BEVERAGES
                      </div>
                    </td>
                  </tr>

                  <tr
                    v-for="(itemsLoop, itemKey) in getStoreItems"
                    :key="itemKey"
                  >
                    <td>
                      {{ itemsLoop && itemsLoop.Item_strDescription }} ({{
                        itemsLoop && itemsLoop.quantity
                      }})
                    </td>
                    <td>
                      ₹{{
                        itemsLoop &&
                        itemsLoop.Item_intPrice * itemsLoop.quantity
                      }}
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td>TOTAL (inclusive of taxes)</td>
                    <td>₹{{ getTotalAmount }}</td>
                  </tr>
                </table>

                <!-- <div class="my-4"> -->
                <!-- <div class="text-muted pb-1 mb-2">
                    APPLY PROMO CODE
                    <span class="float-right cursor-pointer">
                      <img @click="removePromoCode" src="@/assets/img/icons/trash-icon.svg" alt />
                    </span>
                  </div> -->
                <!-- <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Enter Promo code"
                      aria-label="Enter Promo code"
                      aria-describedby="basic-addon2"
                      v-model="promoCode"
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-dark"
                        type="button"
                        @click="verifyPromo({ promo_code: promoCode })"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                  <p
                    class="mb-0 mt-1 text-success fs-12"
                    v-if="getPromoSuccess"
                  >
                    Promo Code successfully applied!
                  </p>
                </div> -->

                <table class="summary-table">
                  <tr v-if="getPromoSuccess">
                    <td class="text-success">Promo Code: {{ getPromoCode }}</td>
                    <td class="text-muted text-success">
                      -₹{{ getPromoAmount }}
                    </td>
                  </tr>
                  <tr>
                    <td class="pt-3">GRAND TOTAL</td>
                    <td class="pt-3 font-weight-normal h5">
                      ₹{{ getTotalAmount.toFixed(2) }}
                      <!-- ₹{{ finalAmount }} -->
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <button
              class="btn w-100"
              :class="
                getStoreItems.length > 0 ? 'btn-primary' : 'btn-light disable'
              "
              @click="
                getIsUserLogged === true && getStoreItems.length > 0
                  ? getFndCinema
                    ? $bvModal.show('fndType')
                    : onHandleOpenModal('cinemaModalModal')
                  : onHandleOpenModal('signInModal')
              "
            >
              <!-- onHandleOpenModal('cinemaModalModal') -->
              PROCEED TO PAY
            </button>
          </div>
          <PromotionsAndOffers />
        </div>
      </div>
      <div class="section-space-75 d-none d-md-block"></div>
      <div class="section-space-25 d-md-none"></div>
    </div>
    <onlyFndProceedToPay :action="getProceedToPayAction" />
    <!-- F&B APPLICATION SUBMITTED MODAL -->

    <!-- <proceedToPay /> -->
    <b-modal
      id="fndType"
      title="Please enter seat booking details"
      class="imp-popup"
      hide-footer
    >
      <div class="p-3">
        <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
          <div class="row mx-0">
            <div class="col-12 my-3 px-3 text-center">
              Please choose whether you want your items to be delivered to your
              seats or will be picked up by you.
            </div>

            <!--  @submit.stop.prevent="
                setfndType({delivery_type, delivery_time })
              " -->
            <div class="col-12 my-3 px-3 mx-auto">
              <form @submit.stop.prevent="verifyBooking">
                <div class="form-row">
                  <div class="col-12 mb-3 mt-2">
                    <input
                      type="text"
                      class="form-control"
                      id="BookingID"
                      placeholder="Booking ID"
                      v-model="booking_id"
                    />
                    <div class="small text-danger" v-if="invalidBookingId">
                      Please enter a valid booking ID
                    </div>
                  </div>
                </div>
                <!--  -->
                <!-- <h1 class="text-center">OR</h1> -->

                <div class="mb-3">
                  <b-dropdown
                    id="dropdown-1"
                    variant="transparent"
                    text="Dropdown Button"
                    class="dd-menu-100 w-100 border rounded fnd-drop"
                  >
                    <template v-slot:button-content>
                      <div
                        class="text-left d-inline-flex text-truncate"
                        style="width: 92%"
                      >
                        {{
                          selectedMovie ? selectedMovie.string : "Select Show"
                        }}
                      </div>
                    </template>
                    <b-dropdown-item
                      v-for="(todaysMovie, todaysMovieKey) in todaysMovies"
                      :key="todaysMovieKey"
                      @click="onHandleTodaysMovie($event, todaysMovie)"
                      >{{ todaysMovie && todaysMovie.string }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
                <!-- <div class="form-row mb-3"> -->
                <!-- <b-dropdown
                    no-caret
                    variant="transparent"
                    class="w-100 border rounded text-left dd-menu-100"
                  >
                    <template v-slot:button-content>
                      <div class="text-left">
                        {{
                          selectedMovie ? selectedMovie.string : "Select Show"
                        }}
                      </div>
                    </template>
                    <b-dropdown-item
                      v-for="(todaysMovie, todaysMovieKey) in todaysMovies"
                      :key="todaysMovieKey"
                      @click="onHandleTodaysMovie($event, todaysMovie)"
                      >{{ todaysMovie && todaysMovie.string }}
                    </b-dropdown-item>
                  </b-dropdown> -->
                <!-- <b-dropdown
                    no-caret
                    variant="transparent"
                    class="w-100 border rounded text-left dd-menu-100"
                  >
                    <template v-slot:button-content>
                      <div class="text-left">
                        {{
                          selectedTime
                            ? selectedTime.Session_dtmRealShow
                            : "Select Time"
                        }}
                      </div>
                    </template>
                    <b-dropdown-item
                      v-for="(todaysMovie, todaysMovieKey) in todaysTimes"
                      :key="todaysMovieKey"
                      @click="onHandleTodaysTime($event, todaysMovie)"
                      >{{
                        todaysMovie &&
                          todaysMovie.Session_dtmRealShow | fulldateparse
                      }}
                    </b-dropdown-item>
                  </b-dropdown>
                  <b-dropdown
                    no-caret
                    variant="transparent"
                    class="w-100 border rounded text-left dd-menu-100"
                  >
                    <template v-slot:button-content>
                      <div class="text-left">
                        {{
                          selectedScreen
                            ? selectedScreen.Screen_strName
                            : "Select Screen"
                        }}
                      </div>
                    </template>
                    <b-dropdown-item
                      v-for="(todaysMovie, todaysMovieKey) in todaysScreens"
                      :key="todaysMovieKey"
                      @click="onHandleTodaysScreen($event, todaysMovie)"
                      >{{ todaysMovie && todaysMovie.Screen_strName }}
                    </b-dropdown-item>
                  </b-dropdown> -->
                <!-- </div> -->
                <div class="col-12 mb-3 px-0">
                  <div class="form-row">
                    <div class="col-3">
                      <input
                        type="text"
                        placeholder="Row"
                        class="form-control"
                        v-model="userRow"
                        min="1"
                        max="1"
                      />
                    </div>
                    <div class="col-3">
                      <input
                        type="number"
                        placeholder="Seat"
                        class="form-control"
                        v-model="userSeat"
                        min="1"
                      />
                    </div>
                  </div>
                </div>
                <!--  -->
                <div class="form-row">
                  <div class="col-md-6 mb-3">
                    <select
                      v-model="delivery_type"
                      class="form-control"
                      required
                    >
                      <!-- <option disabled value>Please select type</option> -->
                      <option value="deliver">Delivery</option>
                      <option value="pickup">Pickup</option>
                    </select>
                  </div>

                  <div class="col-md-6 mb-3">
                    <select
                      v-model="delivery_time"
                      class="form-control"
                      required
                    >
                      <!-- <option disabled value>Please select time</option> -->
                      <option value="before_show">Before Show</option>
                      <option value="during_interval">During Interval</option>
                    </select>
                  </div>
                  <p
                    class="small text-danger"
                    v-if="delivery_type === 'deliver' && !ALLOW_DELIVERY"
                  >
                    Due to the Covid Pandenmic and Government SOP's delivery to
                    seat is currently unavailable, please select your slot for
                    pick up.
                  </p>
                </div>

                <button
                  class="btn btn-primary w-100 mt-3"
                  type="submit"
                  v-if="delivery_type !== 'deliver' && !ALLOW_DELIVERY"
                >
                  SUBMIT
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="rainbow-line">
        <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
      </div>
    </b-modal>

    <b-modal
      id="giftSend"
      title="Booking Verified"
      class="imp-popup"
      hide-footer
    >
      <div class="px-3 py-4">
        <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
          <div class="row">
            <div class="col-12 text-center mb-3">
              <img src="@/assets/img/icons/check-icon.svg" alt="Success" />
            </div>
            <div class="col-12 text-center">
              <p>
                Your details have been verfied! Let’s proceed to add Food &amp;
                Drinks to your cart!
              </p>
            </div>
          </div>
          <div class="row send-gift-modal my-4">
            <div class="col-3">
              <img
                v-lazy="
                  verified_movie && verified_movie.image_path_1
                    ? IMAGE_URL + verified_movie.image_path_1
                    : null
                "
                alt="Movie Banner"
                class="img-fluid"
              />
            </div>
            <div class="col-9 pl-0">
              <p class="title mb-1 text-left">
                {{ verified_movie && verified_movie.Film_strTitle }}
              </p>
              <ul class="list-inline dateTime d-none d-md-block mb-2">
                <li class="list-inline-item">
                  {{
                    verified_movie &&
                    verified_movie.Session_dtmRealShow | dateparse
                  }}
                  |
                  {{
                    verified_movie &&
                    verified_movie.Session_dtmRealShow | timeparse
                  }}
                </li>
              </ul>
              <div class="cinemaName mb-2">
                <p class="mb-0">
                  {{ verified_movie && verified_movie.Cinema_strName }}
                </p>
                <p class="mb-0">
                  {{ verified_movie && verified_movie.cinema_address }}
                </p>
              </div>

              <div class="d-flex">
                <div class="mr-1">Seats:</div>
                <ul class="list-inline mb-0 seats font-weight-bold">
                  <li class="list-inline-item mob-fs-14">
                    {{ verified_movie && verified_movie.strSeatInfo }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-12">
            <button
              class="btn btn-primary w-100"
              @click="$router.push({ path: '/regularBooking' })"
            >
              PROCEED
            </button>
          </div>
        </div>
      </div>
      <div class="rainbow-line">
        <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
      </div>
    </b-modal>
  </section>
</template>

<script>
import onlyFndProceedToPay from "@/components/partials/onlyFndProceedToPay";
import Vue from "vue";
import PromotionsAndOffers from "@/components/partials/promotionsAndOffers";
import TransactionService from "@/apiServices/TransactionService";
import { mapState, mapGetters, mapActions } from "vuex";
import ItemsService from "@/apiServices/ItemsService";
import { IMAGEURL, ALLOW_DELIVERY } from "@/config";

export default {
  data() {
    return {
      ALLOW_DELIVERY,
      booking_id: null,
      invalidBookingId: false,
      IMAGE_URL: IMAGEURL,
      // totalBeforeConviChargesAmount: false,
      totalAmount: false,
      veg: false,
      promoCode: null,
      window: {
        width: 0,
        height: 0,
      },
      items: [],
      itemFilters: [
        {
          filter_id: 0,
          filter_name: "All",
        },
      ],
      selectedFilter: null,
      selectedFilterName: null,
      session: null,
      delivery_type: "pickup",
      delivery_time: "during_interval",
      delivery_type_selector: false,
      delivery_time_selector: false,
      verified_movie: null,
      todaysMovies: [],
      todaysTimes: [],
      todaysScreens: [],
      selectedMovie: null,
      selectedDate: null,
      selectedTime: null,
      selectedScreen: null,
      selectedSession: null,
      userSeat: null,
      userRow: null,
    };
  },
  components: {
    onlyFndProceedToPay,
    PromotionsAndOffers,
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.getPromoCode ? (this.promoCode = this.getPromoCode) : null;
  },
  computed: {
    onChangeVerifyBookingModal: {
      get() {
        return this.getModals.verifyBookingModal;
      },
      set(value) {
        !value ? this.onHandleCloseModal("verifyBookingModal") : undefined;
      },
    },
    ...mapGetters([
      "getSelectedSeats",
      "getBookingSummaryMovie",
      "getBookingSummarySession",
      "getIsUserLogged",
      "getCurPrice",
      "getPromoSuccess",
      "getPromoCode",
      "getPromoAmount",
      "getStoreItems",
      "getCinema",
      "getTotalAmount",
      "getFndCinema",
      "getFndCinemaName",
      "getModals",
      "getFndCinema_has_chefs_corner",
      // "getConvenienceFee",
    ]),
  },
  beforeMount() {
    this.$store.dispatch("clearBookingSummaryStore");
    const { cinema_code } = this.$route.params || null;
    console.log("beforeMount -> cinema_code", cinema_code);
    if (cinema_code && cinema_code != 0) {
      console.log("setting cinema");
      this.setCinemaID({ Cinema_strID: cinema_code });
    }
    if (cinema_code == 0 && !this.getFndCinema) {
      this.onHandleOpenModal("cinemaModalModal");
    }
    if (!this.getFndCinema) {
      this.onHandleOpenModal("cinemaModalModal");
    }
    if (this.getFndCinema) {
      this.$router.push({
        name: "Food And Drinks",
        params: { cinema_code: this.getFndCinema },
      });
    }
    if (!this.getFndCinemaName) {
      this.onHandleOpenModal("cinemaModalModal");
    }

    this.getItems();
    this.getItemFilters();
    this.getTodaysMovieDetails();
    // this.setConvenienceFees();
  },
  methods: {
    methodddd(val) {
      this.convenienceFee = 100;
      return "some";
    },
    getImageObject(fnd) {
      return {
        src: fnd && fnd.image_path ? this.IMAGE_URL + fnd.image_path : null,
        error: "../../../static/img/dummy.svg",
        loading: "../../../static/img/dummy.svg",
      };
    },
    getProceedToPayAction() {
      if (this.getIsUserLogged === true && this.getStoreItems.length > 0) {
        if (this.getFndCinema) {
          return this.$bvModal.show("fndType");
        } else {
          return this.onHandleOpenModal("cinemaModalModal");
        }
      } else {
        return this.onHandleOpenModal("signInModal");
      }
    },
    async getItems() {
      let loader = Vue.$loading.show();
      try {
        let cinema_code = this.getFndCinema ? this.getFndCinema : null;
        let filter_id = this.selectedFilter ? this.selectedFilter : null;
        const response = await ItemsService.GetItems({
          cinema_code,
          filter_id,
        });
        const { data } = response;
        if (data && data.status) {
          this.items = data.data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        console.log("this.items.length", this.items.length);
        // if (this.items.length === 0) {
        //   this.$router.push({ path: "/summary" });
        // }
        loader.hide();
      }
    },
    async getItemFilters() {
      // let loader = Vue.$loading.show();
      try {
        const { data } = await ItemsService.GetItemFilters();
        if (data && data.status) {
          // data.data.forEach(item => {
          //   this.itemFilters.push(item); //??
          // });
          this.itemFilters = data.data;
        }
      } catch (error) {
        console.error(error);
      } finally {
        // loader.hide();
      }
    },
    async getTodaysMovieDetails() {
      console.log("calling");
      // let loader = Vue.$loading.show();
      try {
        let cinema = this.getFndCinema;
        // let movie = this.selectedMovie ? this.selectedMovie.Film_strCode : null;
        // let time = this.selectedTime
        //   ? this.selectedTime.Session_dtmRealShow
        //   : null;
        // let screen = this.selectedScreen
        //   ? this.selectedScreen.Screen_strName
        //   : null;
        const { data } = await TransactionService.GetTodaysMovieDetails({
          cinema,
        });
        if (data && data.status) {
          console.log("data.data :>> ", data.data);
          // if (!this.selectedMovie)
          this.todaysMovies = data.data;
          // // if (!this.selectedTime)
          // this.todaysTimes = data.data.time;
          // // if (!this.selectedScreen)
          // this.todaysScreens = data.data.screen;
          // console.log("this.todaysMovies :>> ", this.todaysMovies);
          // if (data.data.session) {
          //   this.selectedSession = data.data.session[0];
          // }
        }
      } catch (error) {
        console.error(error);
      } finally {
        // loader.hide();
      }
    },
    async onHandleFilter(event, item) {
      console.log("item :>> ", item);
      if (item) {
        this.selectedFilter = item.filter_id;
        this.selectedFilterName = item.filter_name;
        this.getItems();
      }
    },
    async verifyBooking() {
      try {
        if (!this.booking_id && !this.selectedSession) {
          this.$store.dispatch("AppSetting/showErrorNotification", {
            message: "Please enter the booking details.",
          });
        }
        if (this.booking_id) {
          const response = await TransactionService.VerifyBooking({
            booking_id: this.booking_id,
            cinema_code: this.getFndCinema,
          });
          const { data } = response;
          if (data && data.status) {
            this.verified_movie = data.data;
            console.log("data.data VERIFIED", data.data);
            this.setFndCinemaAndSession(data.data);
            this.setfndType({
              delivery_type: this.delivery_type,
              delivery_time: this.delivery_time,
              direct: true,
            });
            this.setUserBookingID({ booking_id: this.booking_id });
            this.$bvModal.hide("fndType");
            this.$bvModal.show("giftSend");
          } else {
            this.invalidBookingId = true;
          }
        } else if (this.selectedSession) {
          if (!this.userSeat || !this.userRow) {
            this.$store.dispatch("AppSetting/showErrorNotification", {
              message: "Please enter the seat details.",
            });
          } else {
            this.setFndCinemaAndSession({
              Cinema_strID: this.getFndCinema,
              Session_lngSessionId: this.selectedSession,
              Film_strCode: this.selectedMovie.Film_strCode,
              strSeatInfo: { row: this.userRow, seat: this.userSeat },
              session: this.selectedMovie,
              movie: this.selectedMovie,
            });
            this.setfndType({
              delivery_type: this.delivery_type,
              delivery_time: this.delivery_time,
              direct: true,
            });
            this.setSeatAndRow({
              seat: this.userSeat,
              row: this.userRow,
            });
            this.$router.push({ path: "/regularBooking" });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    ...mapActions([
      "addFnd",
      "onHandleOpenModal",
      "onHandleCloseModal",
      "cancelTransaction",
      "verifyPromo",
      "removePromoCode",
      "addItem",
      "removeItem",
      "setfndType",
      "setFndCinemaAndSession",
      "setSeatAndRow",
      "setUserBookingID",
      "setCinemaID",
      // "setConvenienceFees",
    ]),
    onHandleTodaysMovie(event, movie) {
      console.log("movie :>> ", movie);
      this.selectedMovie = movie;
      this.selectedSession = movie.Session_lngSessionId;
      // this.getTodaysMovieDetails();
    },
    onHandleTodaysTime(event, movie) {
      this.selectedTime = movie;
      this.getTodaysMovieDetails();
    },
    onHandleTodaysScreen(event, movie) {
      this.selectedScreen = movie;
      this.getTodaysMovieDetails();
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },
};
</script>
<style>
@media (min-width: 1200px) {
  .section-fndCheckout .container {
    max-width: 1250px !important;
  }
}
.fnbCheckout-section ::-webkit-scrollbar-track {
  box-shadow: none;
}

.fnbCheckout-section ::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.fnbCheckout-section ::-webkit-scrollbar-thumb {
  background-color: none;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onlyFndCheckout.vue